import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Link from '@mui/material/Link';
import Hidden from '@mui/material/Hidden';
import i18n from '../../../helpers/I18nJs';

const styles = theme => ({
  root: {
    width: 'auto',
    height: 'auto',
    marginTop: theme.spacing(2),
    '@media (max-width: 1024px) and (min-height: 1024px)': {
      marginTop: theme.spacing(6),
    },
    display: 'block',
    textAlign: 'center',
  },
  reference: {
    minWidth: 0,
    padding: 0,
    marginLeft: theme.spacing(1),
    '& a': {
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: 14,
    },
  },
  copyRight: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: theme.spacing(1),
    fontSize: 14,
  },
  callAction: {
    display: 'block',
    margin: 'auto',
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(6),
    },
    [theme.breakpoints.down('xl')]: {
      marginBottom: theme.spacing(3),
    },
    maxWidth: 'max-content',
    minWidth: 'fit-content',
    padding: 0,
    textAlign: 'center',
    '& p': {
      margin: 0,
      cursor: 'default',
    },
    '& a': {
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 14,
    },
  },
});

const linkActions = {
  signIn: {
    text: (
      <>
        {i18n.t('js.sign_up.footer.sign_in.already_have_account')}
        <br />
        {i18n.t('js.sign_up.footer.sign_in.check_email')}
      </>
    ),
    path: '/recruiter/sign_in',
  },
};

const Footer = (props) => {
  const links = [
    { title: i18n.t('js.sign_up.footer.links.about'), href: 'https://www.rakuna.co/about/' },
    { title: i18n.t('js.sign_up.footer.links.blog'), href: 'https://www.rakuna.co/blog/' },
    { title: i18n.t('js.sign_up.footer.links.privacy_policy'), href: 'https://www.rakuna.co/legal/privacy_policy.pdf' },
    { title: i18n.t('js.sign_up.footer.links.terms_of_service'), href: 'https://secure.rakuna.co/legal/Rakuna_Members_TOS.pdf' },
    { title: i18n.t('js.sign_up.footer.links.support'), href: 'mailto:support@rakuna.co' },
  ];
  const { classes, linkType } = props;
  const action = linkActions[linkType] || { text: '', path: '' };

  return (
    <React.Fragment>
      <Hidden only={['sm', 'lg', 'md', 'xl']}>
        <BottomNavigation>
          <BottomNavigationAction
            showLabel
            component={Link}
            href={action.path}
            label={action.text}
            className={classes.callAction}
          />
        </BottomNavigation>
      </Hidden>
      <Hidden only="xs">
        <BottomNavigation className={classes.root}>
          <BottomNavigationAction
            showLabel
            component={Link}
            href={action.path}
            label={action.text}
            className={classes.callAction}
          />
          {links.map(link => (
            <BottomNavigationAction
              showLabel
              component={Link}
              href={link.href}
              target="_blank"
              label={link.title}
              className={classes.reference}
              key={link.title}
            />
          ))}
          <BottomNavigationAction
            showLabel
            label={i18n.t('js.sign_up.footer.copyright', { year: new Date().getFullYear() })}
            className={classes.callAction}
          />
        </BottomNavigation>
      </Hidden>
    </React.Fragment>
  );
};

Footer.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  linkType: PropTypes.string,
};

Footer.defaultProps = {
  linkType: '',
};

export default withStyles(styles)(Footer);
